import "../styles/footer.css";
import { NAV_LINKS } from "../data/constants";
import EmailMenu from "./EmailMenu";

export default function Footer({ navigate }) {
  return (
    <footer className="footer">
      <div className="footer__icon">🚛</div>
      <div className="footer__brand">RACE CITY TRUCK SOLUTIONS</div>
      <div className="footer__info">
        Statesville, NC &nbsp;|&nbsp; <EmailMenu />
      </div>
      <div className="footer__nav">
        {NAV_LINKS.map((l) => (
          <button key={l} className="footer__nav-link" onClick={() => navigate(l)}>{l}</button>
        ))}
      </div>
      <div className="footer__social">
        <a href="https://www.facebook.com/share/18TJ5hRGy9/?mibextid=wwXlfr" target="_blank" rel="noreferrer" className="footer__social-link footer__social-link--fb">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.268h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
          </svg>
          Facebook
        </a>
      </div>
      <div className="footer__copy">
        &copy; {new Date().getFullYear()} Race City Truck Solutions. All rights reserved.
      </div>
    </footer>
  );
}